export default {
  tabs: {
    home: 'Home',
    menu: 'Menü',
    orders: 'Bestellungen',
  },
};
